import "./modal.css";
import imgClose from "../../images/icons/close.png";
import React from 'react';

const Modal = (props) => {
  return (
    <>
      {props.showModal && (
        <div className=" modal-container">
          <div className=" d-flex justify-content-center align-items-center h-100">
            <div className="modal-content">
              <div
                className={`Actions modal-heading ${
                  props.modal_title ? "space_between" : "justify-content-end"
                }`}
              >
                {props.modal_title && (
                  <h4 className=" title_text mt-2">{props.modal_title}</h4>
                )}
                {props.close && (
                  <button className="btnClose" onClick={props.hideModal}>
                    <img alt="close" src={imgClose} className="imgClose" />
                  </button>
                )}
              </div>
              {props.children}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
